// extracted by mini-css-extract-plugin
module.exports = {"noResult":"NoResult_noResult__4j8Zt","k":"NoResult_k__egvpW"};